;{
    window.packageInfo = window.packageInfo || {};
    window.packageInfo['menucombined'] = {
      info: 'Infor Public Sector v11.2.2',
      date: '1742861848331',
      revisionNumber: '2'
    };
  };